
import Vue from "vue";
export default Vue.extend({
	props: {
		value: [Number, String],
		color: String,
	},
	computed: {
		width():string | null {
			if (this.value === undefined) return null;
			return this.value + "%";
		},
		undetermind():boolean {
			return this.value == null;
		}
	},
});
